module.exports = __webpack_public_path__ + "media/goforajourney/img/madrid-card-fa79024f8a6d0f9994cca1061e6d3c46.jpeg";